import axios from 'axios';
import { javaHost } from '@/bin/javaSetting';

const getToken = (token) => {
  const params = new URLSearchParams();
  params.append('ww_token', token);
  params.append('channelCode', '014X0JQ');

  // /apis 前缀在 ajaxConf 中被映射为 javaHost，这里直接拼接
  return axios.get(`${javaHost}/baohuo-yuanchuang/migu/api/v1/getToken?${params.toString()}`)
    .then(res => res.data);
};

export async function toPublishPage(data) {
  const videoUrl =  encodeURIComponent(data.videoUrl); // 视频地址
  const coverUrl =  encodeURIComponent(data.coverUrl); // 视频封面地址
  const params = data.params || ''; // 其他参数使用migu传递的
  const queryFromMigu = localStorage.getItem('queryFromMigu') || ''; // 其他参数使用migu传递的
  const commonPub = localStorage.getItem('commonPub') || ''; // 公共发布标识
  
  let host = `https://y.migu.cn/app/v5/p/publish-mid/index.html?videoCover=${coverUrl}`;
  
  // 根据 commonPub 标识走不同的发布逻辑
  if (commonPub) {
    // 获取 ww_token 和 wwid
    const session_id = localStorage.getItem('session_id');
    if (session_id) {
      try {
        const tokenRes = await getToken(session_id);
        if (tokenRes.code === 200 && tokenRes.data) {
          host = `https://y.migu.cn/app/v5/p/publish-mid/index.html?videoCover=${coverUrl}&token=${tokenRes.data}&tokenType=MGPT`;
        }
      } catch (error) {
        console.error('Failed to get token:', error);
      }
    }
  } else if(queryFromMigu.includes('urlfrom=FY')) {
    // 识别应用链接里带urlfrom=FY，发布时跳到新春营销的发布页
    host = `https://y.migu.cn/app/v5/zt/2025/newyear-publish/index.html?coverUrl=${coverUrl}`;
  }
  
  const url = `${host}&videoUrl=${videoUrl}&${queryFromMigu}&${params}`;
  window.location.href = url;
}